import { forwardRef, type InputHTMLAttributes } from 'react';

/**
 * Native date-input med max som begränsar året till 4 siffror.
 * Utan max accepterar Chromium upp till 6 siffror i årsfältet, så manuell
 * inmatning (t.ex. 20260703) fastnar på 5:e tecknet i stället för att
 * hoppa till månad — till skillnad från type="time".
 *
 * Tomt/ofullständigt värde vid inmatning måste få uppdatera state (annars
 * fastnar slutdatum). Konsumenter ska använda localDateAndTimeToUtcIso /
 * NaN-guards så tomt värde inte kraschar render.
 */
export const DATE_INPUT_MAX = '9999-12-31';
export const DATE_INPUT_MIN = '1000-01-01';

export type DateInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

const DateInput = forwardRef<HTMLInputElement, DateInputProps>(function DateInput(
  { min = DATE_INPUT_MIN, max = DATE_INPUT_MAX, ...rest },
  ref,
) {
  return <input ref={ref} type="date" min={min} max={max} {...rest} />;
});

export default DateInput;
